export const GET_CARBON_SAVING = 'GET_CARBON_SAVING'
export const GET_CARBON_SAVING_SUCCESS = 'GET_CARBON_SAVING_SUCCESS'
export const GET_CARBON_SAVING_ERROR = 'GET_CARBON_SAVING_ERROR'
export const RESET_GET_CARBON_SAVING = 'RESET_GET_CARBON_SAVING'
